import { useDogs } from '../../Hooks/useDogs'

import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

import Card from '../Card/Card'
import Paged from '../Paged/Paged'

import dogFoot from '../../imgs/dogfoot.png'

const Cards = () => {
  const navigate = useNavigate()
  const { showAllDogs, temps, lenguage } = useSelector((state) => state)
  const {
    allPages,
    dogs,
    loading,
    numPages,
    orderHandler,
    originFilterHandler,
    pagHandler,
    search,
    searchClearHandler,
    searchDispatch,
    searchHandler,
    showDogs,
    tempHandler,
    filters,
  } = useDogs()

  useEffect(() => {
    if (temps instanceof Error || showAllDogs instanceof Error) {
      navigate('/')
      alert(
        lenguage
          ? 'Oops, a problem occurred, try again later. Or refresh the page'
          : 'Oops, se ha producido un problema, inténtelo de nuevo más tarde. O actualice la página'
      )
    }
  }, [temps, showAllDogs]) //eslint-disable-line

  return (
    <>
      <div className="cards_conteiner">
        <section className="sec-searchname">
          <div className="container-searchname">
            <input
              type="text"
              name="search"
              value={search}
              onChange={searchHandler}
              placeholder={lenguage ? 'Search by name' : 'Buscar por nombre'}
            />
            <label htmlFor="search" style={search ? { display: 'block' } : {}}>
              {lenguage ? 'Search by name' : 'Buscar por nombre'}
            </label>
          </div>
          <div className="btns-search">
            <button onClick={searchDispatch} className="btn-search">
              {lenguage ? 'Search' : 'Buscar'}
            </button>
            <button onClick={searchClearHandler} className="btn-cleansearch">
              {lenguage ? 'Clean filters' : 'Limpiar filtros'}
            </button>
          </div>
        </section>
        <section className="sec-filterOrder">
          <select
            name="originFilter"
            onChange={originFilterHandler}
            className="select-filtOrigin"
          >
            <option value="#">{lenguage ? 'Origin' : 'Origen'}</option>
            <option value="ALL">
              {lenguage ? 'All breeds' : 'Todas las razas'}
            </option>
            <option value="DB">
              {lenguage ? 'Created breeds' : 'Razas creadas'}
            </option>
            <option value="API">{lenguage ? 'API breeds' : 'Razas API'}</option>
          </select>
          <select
            name="filterTemps"
            onChange={tempHandler}
            className="select-filtTemps"
          >
            <option value="$">
              {lenguage ? 'Temperaments' : 'Temperamentos'}
            </option>
            <option value="#">
              {lenguage ? 'Alldogs' : 'Todas las razas'}
            </option>
            {temps instanceof Error === false &&
              temps?.map((temp) => (
                <option key={temp.id} value={temp.name}>
                  {temp.name}
                </option>
              ))}
            {/* </optgroup> */}
          </select>
          <select
            name="ordenName"
            onChange={orderHandler}
            className="select-order"
          >
            <option value="#">{lenguage ? 'Order' : 'Orden'}</option>
            <option value="ASC">
              {lenguage ? 'Name ascendant' : 'Nombre ascendente'}
            </option>
            <option value="DESC">
              {lenguage ? 'Name descending' : 'Nombre Descendente'}
            </option>
            <option value="ASCW">
              {lenguage ? 'Weight ascendant' : 'Peso ascendente'}
            </option>
            <option value="DESCW">
              {lenguage ? 'Weight descending' : 'Peso descendente'}
            </option>

            <option value="ASCLF">
              {lenguage ? 'Life span ascendant' : 'Eperanza de vida ascendente'}
            </option>
            <option value="DESCLF">
              {lenguage
                ? 'Life span descending'
                : 'Esperanza de vida descendente'}
            </option>
          </select>
        </section>
        <section className="sec-listFilts">
          <ul className="list-filters">
            {filters.map((filt, i) => (
              <li key={i}>{filt}</li>
            ))}
          </ul>
        </section>
        {loading ? (
          <div>
            <div className="loading-home">
              <img src={dogFoot} alt="dogfoot" />
              <h3>{lenguage ? 'Loading...' : 'Cargando...'}</h3>
            </div>
            <div className="notFound-home">
              <h3>
                {lenguage ? 'Breeds not found' : 'No se encontraron razas'}
              </h3>
            </div>
          </div>
        ) : null}

        {showDogs.length > 8 && (
          <Paged handlers={{ allPages, numPages, pagHandler }} />
        )}
        <section className="allcards-conteiner">
          {showAllDogs instanceof Error === false &&
            dogs?.map((dog, index) => <Card key={index} dog={dog} />)}
        </section>
        {dogs.length === 8 && showDogs.length > 8 && (
          <Paged handlers={{ allPages, numPages, pagHandler }} />
        )}
      </div>
    </>
  )
}
export default Cards
